import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import type { PatrimoinePoint } from '@app/shared';
import { formatCents } from '@/lib/format';

export function PatrimoineChart({ points, currency }: { points: readonly PatrimoinePoint[]; currency: string }) {
  const data = points.map((point) => ({
    date: point.date,
    valeur: point.valueCents / 100,
    crd: point.outstandingCents / 100,
    net: point.netCents / 100,
  }));

  return (
    <div className="h-72 w-full">
      <ResponsiveContainer>
        <LineChart data={data} margin={{ top: 8, right: 8, left: 8, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" className="stroke-border" />
          <XAxis dataKey="date" tick={{ fontSize: 12 }} />
          <YAxis
            tick={{ fontSize: 12 }}
            tickFormatter={(value: number) => formatCents(Math.round(value * 100), currency)}
            width={80}
          />
          <Tooltip formatter={(value) => formatCents(Math.round(Number(value) * 100), currency)} />
          <Legend />
          <Line type="monotone" dataKey="valeur" name="Valeur estimée" stroke="var(--color-primary)" strokeWidth={2} dot />
          <Line type="monotone" dataKey="crd" name="Capital restant dû" stroke="var(--color-destructive)" strokeWidth={2} dot />
          <Line type="monotone" dataKey="net" name="Net" stroke="var(--color-muted-foreground)" strokeWidth={2} dot />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
